import { sendRequest } from './index';
import { API_CONSULTATION_URL } from '@core/constants/API';

export const consultations = {    
    POST: (payload) =>
        sendRequest({
            url: `${API_CONSULTATION_URL}`,
            method: 'POST',
        }),
    GET: () => {
        return sendRequest({
            url: `${API_CONSULTATION_URL}`,
            method: 'GET'
        });
    }
};